var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9742 26.0596C13.5282 26.0596 8.02344 27.0342 8.02344 30.9373C8.02344 34.8405 13.4933 35.85 19.9742 35.85C26.4203 35.85 31.9234 34.8739 31.9234 30.9723C31.9234 27.0707 26.4552 26.0596 19.9742 26.0596Z",
    stroke: "#0077CC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9748 20.4929C24.205 20.4929 27.6335 17.0627 27.6335 12.8326C27.6335 8.6024 24.205 5.17383 19.9748 5.17383C15.7447 5.17383 12.3145 8.6024 12.3145 12.8326C12.3002 17.0484 15.7066 20.4786 19.9208 20.4929H19.9748Z",
    stroke: "#0077CC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/customer-icon.824a9d81054c20ff9728cfd123b5a472.svg";
export { ForwardRef as ReactComponent };